<template>
  <li>
    <a @click="showLoadCheckModal" data-toggle="modal" data-target=".modal-load-check">
      <p class="load-reference">
        {{ decorated.reference_number }}

        <span class="load-status pull-right" :class="decorated.weighbridge_status_class">
          {{ decorated.weighbridge_status_text }}
        </span>
      </p>
      <div class="row">
        <div class="col-xs-6 col-md-4 col-lg-2">
          <p>
            <strong>Loading Date</strong><br />
            {{ decorated.loading_date }}
          </p>
        </div>
        <div class="col-xs-6 col-md-4 col-lg-2">
          <p>
            <strong>Delivery Date</strong><br />
            {{ decorated.delivery_date }}
          </p>
        </div>
        <div class="col-xs-6 col-md-4 col-lg-2">
          <p>
            <strong>Rego</strong><br />
            {{ decorated.registration }}
          </p>
        </div>
        <div class="col-xs-6 col-md-4 col-lg-2">
          <p>
            <strong>Configuration</strong><br />
            {{ decorated.configuration_description }}
          </p>
        </div>
        <div class="col-xs-6 col-md-4 col-lg-2">
          <p class="truncate">
            <strong>From</strong><br />
            {{ decorated.location_from.formatted_name }}
          </p>
        </div>
        <div class="col-xs-6 col-md-4 col-lg-2">
          <p class="truncate">
            <strong>To</strong><br />
            {{ decorated.location_to.formatted_name }}
          </p>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { SET_LOAD, SET_JOB } from 'vx/mutations'
  import { LoadDecorator } from 'decorators'

  export default {
    props: ['load'],

    computed: {
      decorated () {
        return new LoadDecorator(this.load)
      }
    },

    methods: {
      ...mapMutations('load', [SET_LOAD]),
      ...mapMutations('job', [SET_JOB]),

      /**
       * Show the load check modal by setting the active load and job.
       *
       * @return void
       */
      showLoadCheckModal () {
        this[SET_LOAD](this.load)

        this[SET_JOB](this.load.job)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadCheckListItem.vue?6dd64fb6